import { useLocation } from 'wouter';
import useUserStore from '../../../common/src/stores/useUserStore';
import useDataStore from '../../../common/src/stores/useDataStore';
import useFiltersStore from '../../../common/src/stores/useFiltersStore';

const PAGE_NAMES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/daily-market': 'Mercado Diario',
  '/evolution-market': 'Evolucion de Mercado',
  '/logbook': 'Bitacora',
  '/settlements/summary': 'Resumen de Liquidaciones',
  '/settlements/details': 'Detalle de Liquidaciones',
  '/settlements/control': 'Control de Liquidaciones',
  '/settlements/comparative-clients': 'Comparativo Clientes',
  '/settlements/comparative-exporters': 'Comparativo Exportadores',
  '/settlements/comparative-exporters-evolution':
    'Evolucion Comparativo Exportadores',
  '/settlements/comparative-exporters-unified':
    'Resultados FOB/CIF vs Industria',
  '/settlements/comparative-exporters-costs': 'Costos vs Industria',
  '/settlements/comparative-sales': 'Precios vs Industria',
  '/settlements/comparative-industry': 'Comparativo Industria',
  '/settlements/liquidated-mix': 'Mix Liquidado',
  '/settlements/shipments-industry': 'Mix Liquidado',
  '/settlements/comparative-seasons': 'Comparativo Temporadas',
  '/settlements/claims': 'Compensaciones',
  '/pre-settlements': 'Preliquidacion Productor',
  '/shipments/summary': 'Resumen de Despachos',
  '/shipments/details': 'Detalle de Despachos',
  '/shipments/arrivals': 'Gestor de Arribos',
  '/shipments/schedule': 'Cronograma de Naves',
  '/commercial-plan': 'Programa Comercial',
  '/commercial-plan/summary': 'Programa Comercial — Resumen',
  '/commercial-plan/detail': 'Programa Comercial — Gestionar compromisos',
  '/business': 'Resumen de Negocio',
  '/team': 'Equipo',
  '/settings': 'Configuracion',
  '/current-account': 'Cuenta Corriente',
};

function getPageName(path: string): string {
  // Exact match first
  if (PAGE_NAMES[path]) return PAGE_NAMES[path];

  // Try matching base path (for routes like /settlements/details/123)
  const basePath = path.replace(/\/\d+$/, '');
  if (PAGE_NAMES[basePath]) return PAGE_NAMES[basePath];

  return 'Pagina desconocida';
}

export interface PageContext {
  currentPage: string;
  pageName: string;
  selectedSeason: string;
  selectedSpecies: { id: number; name: string } | null;
  priceLevel: string;
  exporterName: string | null;
}

export function usePageContext(): PageContext {
  const [location] = useLocation();
  const { userProfile, exporter } = useUserStore();
  const { selectedSpecies, priceLevel } = useDataStore();
  const { selectedSeason } = useFiltersStore();

  return {
    currentPage: location,
    pageName: getPageName(location),
    selectedSeason: selectedSeason || 'unknown',
    selectedSpecies: selectedSpecies
      ? { id: selectedSpecies.id, name: selectedSpecies.name }
      : null,
    priceLevel: priceLevel || 'market',
    exporterName: exporter?.name || userProfile?.exporter?.name || null,
  };
}
